
  document.getElementById('view-more-btn').addEventListener('click', function() {
    const hiddenBlogs = document.querySelectorAll('.hidden-blog');
    hiddenBlogs.forEach(blog => blog.classList.remove('hidden-blog'));
    this.style.display = 'none'; // Hide the button after showing all blogs
  });

